var map = {
	"./banking/calendar.svg": 1360,
	"./banking/credit.svg": 1361,
	"./banking/current.svg": 1362,
	"./banking/graduate-account.svg": 1363,
	"./banking/loot.svg": 1364,
	"./banking/personal-loans.svg": 1365,
	"./banking/prepaid.svg": 1366,
	"./banking/savings.svg": 1367,
	"./banking/senior-account.svg": 1368,
	"./banking/standard-account.svg": 1369,
	"./banking/student-account.svg": 1370,
	"./brand/facebook.svg": 625,
	"./brand/instagram.svg": 626,
	"./brand/linkedin.svg": 627,
	"./brand/tiktok.svg": 628,
	"./brand/twitter.svg": 629,
	"./brand/youtube.svg": 630,
	"./broadband/broadband.svg": 1371,
	"./broadband/speed-gauge.svg": 1354,
	"./energy/bolt.svg": 1372,
	"./energy/business.svg": 1373,
	"./energy/energy.svg": 1374,
	"./energy/gas.svg": 1375,
	"./energy/lamp.svg": 1376,
	"./generic/Stars.svg": 1264,
	"./generic/badge.svg": 1377,
	"./generic/devices.svg": 1378,
	"./generic/discount-tag.svg": 1379,
	"./generic/globe.svg": 1380,
	"./generic/hands-heart.svg": 1381,
	"./generic/newspaper.svg": 1382,
	"./generic/person-headest.svg": 1383,
	"./generic/radio-tower.svg": 1384,
	"./generic/review.svg": 1317,
	"./generic/speech.svg": 1385,
	"./generic/star.svg": 1340,
	"./generic/thumbs.svg": 1386,
	"./generic/white-stars.svg": 624,
	"./generic/woman-headset.svg": 1387,
	"./insurance/car.svg": 1388,
	"./insurance/health.svg": 1389,
	"./insurance/home.svg": 1390,
	"./insurance/income.svg": 1391,
	"./insurance/life.svg": 1392,
	"./insurance/mort-prot.svg": 1393,
	"./insurance/serious-ill.svg": 1394,
	"./mortgage/block.svg": 1395,
	"./mortgage/house.svg": 1396,
	"./mortgage/key.svg": 1397,
	"./mortgage/lifetimeHouse.svg": 1398,
	"./mortgage/mortgage.svg": 1399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1265;